var render = function (_h,_vm) {var _c=_vm._c;return _c('div',{class:[ 'loader-spinner', _vm.props.className ]},[_c('div',{staticClass:"loader-spinner__inner"},[_c('div',{staticClass:"loader-spinner__left"},[_c('div',{class:{
          'loader-spinner__half-circle': true,
          'loader-spinner__half-circle--left': !_vm.props.changeColor,
          'loader-spinner__half-circle--left-white': _vm.props.changeColor
        }})]),_c('div',{staticClass:"loader-spinner__right"},[_c('div',{class:{
          'loader-spinner__half-circle': true,
          'loader-spinner__half-circle--right': !_vm.props.changeColor,
          'loader-spinner__half-circle--right-white': _vm.props.changeColor
        }})])])])}
var staticRenderFns = []

export { render, staticRenderFns }